export default "__VITE_ASSET__CXonOuv___"